package user.containers

import antd.message.message
import com.jingfangpai.api.clients.UserApiClient
import com.jingfangpai.common.data.type.Date
import com.jingfangpai.common.orm.mapping.enums.UserSex
import com.jingfangpai.user.model.UserAuthData
import kotlinx.browser.window
import user.components.loginComponent
import user.service.AuthService
import react.*
import react.dom.div
import setTitle
import user.components.registerComponent

external interface RegisterPageProps:RProps {
    var redirectUrl:String?
}

val RegisterPageContext = createContext("")

val RegisterProvider = functionalComponent<RegisterPageProps> {
        props->

    setTitle("注册")

    val (errorMessage,setErrorMessage) = useState("")

    fun onRegister(userName:String, sex: UserSex, birthday: Date?, mobilePhone:String, account:String, password:String){
         console.log(userName,password)
        val hide = message.loading("正在为您注册，请稍候...")
        UserApiClient.register(userName,sex,birthday,mobilePhone,account,password,{
            apiResponse ->
            window.setTimeout(hide,1)
            if(apiResponse.ok()){
                if(apiResponse.data!=null){
                    AuthService.setUserAuthData(apiResponse.data!!,apiResponse.data!!.jwt?:"")
                    if(!props.redirectUrl.isNullOrBlank()){
                        window.location.href = props.redirectUrl!!
                    }else{
                        window.location.href = "/"
                    }
                }else{
                    setErrorMessage("注册失败了,返回的授权信息为空")
                }
            }else{
               setErrorMessage("注册失败了,${apiResponse.message}")
            }
        },{setErrorMessage("注册失败了,${it.message}")})
    }

    fun onTyping(){
        setErrorMessage("");
    }

    RegisterPageContext.Provider(errorMessage) {
        div("register-page") {
            registerComponent(::onRegister,::onTyping)
        }
    }
}

fun RBuilder.registerPage(redirectUrl:String) {
    child(RegisterProvider){
        attrs.redirectUrl = redirectUrl
    }
}
